module.exports = __webpack_public_path__ + "assets/img/low_priority.57c51dda.svg";